module.exports = __webpack_public_path__ + "static/media/6.66b04fd9.svg";